<template>


  <div class="container container-tabs">


    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">

      <el-tab-pane name="all" class="to-searh">
        <span slot="label" class="table-title">全部</span>
      </el-tab-pane>

      <el-tab-pane :name="String(item.val)" v-for="(item, index) in value_status_array" :key="index" class="to-searh">
        <span slot="label" class="table-title">{{ item.alias }}</span>
      </el-tab-pane>



      <div class="handle-box">





        <el-button type="primary" icon="el-icon-search" @click="searchDemandLists">搜索</el-button>
        <el-button @click="add_isShow=!add_isShow;">添加</el-button>
        <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>


      </div>


    </el-tabs>


    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" prop="consumer_demand_code"></el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <div class="more-style">

              <el-form-item label="创建详细时间:">
                <span>{{ props.row.time.YmdHis }}</span>
              </el-form-item>

            </div>

          </el-form>
        </template>
      </el-table-column>





      <el-table-column prop="id" label="id" width="80">
      </el-table-column>

      <el-table-column prop="label" label="喜好标签名" width="150">
      </el-table-column>


      <el-table-column prop="time.Ymd" label="创建时间">
      </el-table-column>



      <el-table-column label="管理状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status.val=='0'?'danger':(scope.row.status.val=='1'?'':'warning')">
            {{scope.row.status.alias}}</el-tag>
        </template>
      </el-table-column>



      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-button type="primary"
            @click="edit_isShow = !edit_isShow; edit_status_data = scope.row.consumer_demand_code;">

            编辑


          </el-button>

        </template>
      </el-table-column>
    </el-table>

    <!-- 批量删除按钮 -->
    <el-button type="primary" icon="el-icon-delete" class="handle-del mr10" @click="deleteData"
      style="margin-top: 20px;">批量删除</el-button>


    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>

    <!-- 添加组件 -->
    <addDemand :isShow="add_isShow" @onSubmit="demandLists"></addDemand>

    <!-- 编辑组件 -->
    <editDemand :isShow="edit_isShow" :data="edit_status_data" @onSubmit="demandLists"></editDemand>


  </div>


</template>

<script>
  var _this;
  import addDemand from './addDemand.vue';
  import editDemand from './editDemand.vue';
  export default {
    components: {
      addDemand,
      editDemand
    },
    data() {
      return {

        // 传入子组件的数据
        add_status_data: '',
        edit_status_data: '',



        // 批量删除
        delConsumerSubmit_data: {
          consumer_demand_code_array: []
        },
        delConsumerSubmit_rules: {
          consumer_demand_code_array: {
            placeholder: '权限模块',
            rules: {
              required: false,
              message: '权限模块代码数组(json)',
              regulation: 'special',
              rulesData: 'json_array'
            }
          }
        },

        // 抽屉开关按钮
        edit_isShow: false,

        add_isShow: false,

        // 选项卡默认选中项
        activeName: 'all',





        // 下拉搜索管理状态
        value_status_code: '',
        value_status_array: [],

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          status: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },
      };
    },
    created() {
      _this = this;
      _this.demandLists();


    },

    methods: {
      searchDemandLists() {
        _this.search_data.page = 1;
        _this.demandLists();
      },
      // 选项卡选中事件
      handleClick(tab, event) {
        // 点击的选项卡所对应的val值
        console.log(tab.name);

        if (tab.name != 'all') {
          _this.search_data.status = tab.name;
        } else {
          _this.search_data.status = '';
        }
        _this.search_data.page = 1;
        _this.demandLists();

      },

      // 搜索司机列表
      demandLists() {
        _this.$post(
            "/consumer/demandLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data.result;
            _this.result_data = res.data;


            _this.value_status_array = _this.tableData[0].status.select_array;
            console.log(_this.tableData);

          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.demandLists();

      },
      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].consumer_demand_code);

        }
        _this.delConsumerSubmit_data.consumer_demand_code_array = datalist;
      },
      // 批量删除
      deleteData() {

        if (_this.delConsumerSubmit_data.consumer_demand_code_array.length == 0) {

          _this.$message.warning('请至少勾选一条数据');

          return;
        }


        _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {
          _this.delConsumerSubmit_data.consumer_demand_code_array = JSON.stringify(_this.delConsumerSubmit_data
            .consumer_demand_code_array);

          _this.$post(
              "/consumer/deleteDemandSubmit",
              _this.delConsumerSubmit_data,
              _this.delConsumerSubmit_rules
            )
            .then(res => {

              _this.$message.success('删除成功!');

              //初始化显示列表
              _this.demandLists();

            }).catch((err) => {

            })

        }).catch(() => {

          _this.$message.info('已取消删除');

        });


      },




      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },


    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-dropdown {
    vertical-align: top;
  }

  .el-dropdown+.el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>